// extracted by mini-css-extract-plugin
export default {"title":"PropertiesHeader__title__LPtG9","subtitle":"PropertiesHeader__subtitle__wt5r4"};